import React from "react";
import { Card, Row, Spinner } from "react-bootstrap";

export const wait = (ms: number) =>
  new Promise(async (resolve) => {
    await setTimeout(resolve, ms);
  });

export const loadingCard = () => {
  return (
    <Card className="p-3">
      <Card.Body>
        <Row className="text-center">
          <span className="mt-2 mb-2">
            <Spinner animation="border" style={{ color: "#F6893D" }} />
          </span>
        </Row>
      </Card.Body>
    </Card>
  );
};

export const loadingRow = () => {
  return (
    <Row className="text-center">
      <span className="mt-2 mb-2">
        <Spinner animation="border" style={{ color: "#F6893D" }} />
      </span>
    </Row>
  );
};
